<template>
<div style="float: left; margin-top: 15px">
  <img class="icon" v-for="svg in svgs" :src="svg" :key="svg" v-on:click="svgSelected(svg)" />
</div>
</template>

<script>
import axios from "axios";

export default {
  name: 'IconPicker',
  props: {
    event: String
  },
  data: function() {
    return {
      svgs: []
    }
  },
  mounted: function() {
    // Currently the event id is hard-coded as the API only returns one event
    // TODO: You need to update this as we have more events.
    // TODO 1 -> See Readme.md
    const url =
      `https://jti-itemizr.kontrollfeld.com/api/v1/events/${this.event}?include=field_graphics`;
    axios.get(url).then(res => {
      const graphicIds = res.data.included.map(i => i.id);
      return graphicIds;
    })
    .then(ids => {
      const defers = [];
      for (let id of ids) {
        defers.push(axios.get(`https://jti-itemizr.kontrollfeld.com/api/v1/graphics/${id}?include=field_graphic_image`));
      }
      return Promise.all(defers);
    })
    .then(results => {
      const fileUrls = results.map(res => res.data.included[0].links.self.href);
      return fileUrls;
    })
    .then(urls => {
      const defers = [];
      for (let url of urls) {
        defers.push(axios.get(url));
      }
      return Promise.all(defers);
    })
    .then(fileResults => {
      return fileResults.map(res => 'https://jti-itemizr.kontrollfeld.com' + res.data.data.attributes.uri.url);
    })
    .then(graphics => {
      this.svgs = graphics;
    });
  },
  methods: {
    svgSelected(url) {
      this.$emit('svg', url);
    }
  }
}
</script>

<style scoped>
.icon {
  width: 75px;
  cursor: pointer;
}
</style>